import cx from "classnames";
import moment from "moment-timezone"; // eslint-disable-line no-restricted-imports -- deprecated usage
import { Component } from "react";
import _ from "underscore";
import { t } from "ttag";

import YearPicker from "metabase/components/YearPicker";
import CS from "metabase/css/core/index.css";

import {
  MonthContainer,
  MonthList,
  MonthRoot,
} from "./DateMonthYearWidget.styled";

type Props = {
  value: string;
  setValue: (v: string) => void;
  minStartMonthOffset?: string;
  onClose: () => void;
};

type State = {
  month: number | null;
  year: number;
  showMinDateWarning: boolean;
};

export class DateMonthYearWidget extends Component<Props, State> {
  state: State = {
    month: null,
    year: moment().year(),
    showMinDateWarning: false,
  };

  constructor(props: Props) {
    super(props);

    const initial = moment(this.props.value, "YYYY-MM");
    if (initial.isValid()) {
      this.state = {
        month: initial.month(),
        year: initial.year(),
        showMinDateWarning: false,
      };
    } else {
      this.state = {
        month: null,
        year: moment().year(),
        showMinDateWarning: false,
      };
    }
  }

  componentWillUnmount() {
    const { month, year } = this.state;
    if (month != null && year != null) {
      const value = moment().year(year).month(month).format("YYYY-MM");
      if (this.props.value !== value) {
        this.props.setValue(value);
      }
    }
  }

  render() {
    const { onClose } = this.props;
    const { month, year } = this.state;
    return (
      <div style={{ maxWidth: 320 }}>
        <div className={cx(CS.borderBottom, CS.flex, CS.justifyCenter, CS.py1)}>
          <YearPicker
            value={year}
            onChange={year => this.setState({ year: year })}
          />
        </div>
        <MonthList>
          {_.range(0, 12).map(m => (
            <MonthContainer key={m}>
              <Month
                month={m}
                selected={m === month}
                onClick={() => {
                  console.log(this.props.minStartMonthOffset);
                  const { minStartMonthOffset } = this.props;

                  if(minStartMonthOffset === undefined){
                    this.setState({ month: m, showMinDateWarning: false }, onClose);
                    return;
                  }else{
                  // 计算最早允许选择的月份
                  const offset = Number(minStartMonthOffset) -1 || 0;
                  const now = moment();
                  const minAllowed = moment(now).subtract(offset, "months");
                
                  // 用户选择的时间
                  const selected = moment().year(year).month(m);

                  // 判断是否早于最早可选月份
                  const tooEarly = selected.isBefore(minAllowed, "month");
                  if (!tooEarly) {
                    this.setState({ month: m, showMinDateWarning: false }, onClose);
                  } else {
                    this.setState({ showMinDateWarning: true });
                  }
                }
                }}
                  
              />
            </MonthContainer>
          ))}
        </MonthList>
        {this.state.showMinDateWarning && (
          <div style={{color:'#ff0000',marginBottom:'11px',marginTop:'10px'}}>{t`The start date is earlier than the earliest date limit`}</div>
        )}
        </div>
    );
  }
}

interface MonthProp {
  month: number;
  selected: boolean;
  onClick: () => void;
}

const Month = ({ month, selected, onClick }: MonthProp) => (
  <MonthRoot isSelected={selected} aria-selected={selected} onClick={onClick}>
    {moment().month(month).format("MMMM")}
  </MonthRoot>
);
